import React from "react";
import InputArea from "../../../common/components/FormFields/InputArea";
import { useForm, useFormContext } from "react-hook-form";

export default function GynacHOPI(props) {
  // const defaultValues = {
  //     hopi: "",
  //   };
  const {
    control,
    watch,
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useFormContext({
    mode: "onChange",
    // defaultValues,
  });
  return (
    <div>
      <div className="flex justify-between bg-[#FEFFCA] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-1">HOPI</p>
      </div>
      <div className="  p-1 overflow-auto border pb-1 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        {
          props.pastData === null ? (
            <InputArea
            disabled={props.pastData !== null}
            name="hopi"
            placeholder="HOPI"
            label="HOPI"
              control={control}
              minRows={3}
              sx={{
                height:"135px"
              }}
          />
          ):(
            <div>{props.pastData?.presentIllnessHistory}</div>
          )
        }
       
      </div>
    </div>
  );
}
